





import { Component, Model, Vue, Prop, Watch } from "vue-property-decorator";
import IEqual from "component-models/src/iequal";
import ListViewItem from 'list-view/src/listviewitem';

//компонент "обертка" для удобного использования ui-dropdown
@Component({
  name: "ui-usable-dropdown"
})
export default class UiUsableDropdownComponent extends Vue {
  @Prop({ default: () => {[]}, type: Array}) items!: any[];
  @Prop({ default: 'id', type: String}) keyField: string;
  @Prop({ default: false, type: Boolean}) autocomplete: boolean;
  @Prop({ default: false, type: Boolean}) scroll: boolean;
  @Prop({ default: false, type: Boolean}) multiselect: boolean;
  @Prop({ default: false, type: Boolean}) required: boolean;
  @Prop({ default: () => [] as string[]}) nameFields: string[];
  @Model('onSelected', {type: [String, Number, Object, Array]}) value: any | string | number;
  dropdownItems: Array<ListViewItem<any>> = new Array<ListViewItem<any>>();
  @Watch('dropdownItems', { deep: true })
  onDropdownListChanged(value: ListViewItem<any> | ListViewItem<any>[]) {
    var result = Array.isArray(value)? 
     value.filter(x=>x.Selected).map(x=>this.getListViewValue(x)) : this.getListViewValue(value);
     if (JSON.stringify(this.items) == JSON.stringify(result)) {
       return;
     }
     if (result.length == 0) {
       this.$emit('onSelected', null);
       return;
     }
     this.$emit('onSelected', result.length == 1 && !this.multiselect ? result[0]: result);
  }
  getValue(value: any): any {
    if (!(value as Object).hasOwnProperty(this.keyField)) {
      console.warn(`Объект ${value} не имеет поля ${this.keyField}`);
    }
    return value[this.keyField];
  }
  getListViewValue(value: ListViewItem<any>): any {
    return value && value.Value ? this.getValue(value.Value) : null;
  }
  getString(value: ListViewItem<any>): any {
    let name = '';
    this.nameFields.forEach(nameField => {
      if (!(value as Object).hasOwnProperty(nameField)) {
        console.warn(`Объект ${value} не имеет поля ${nameField}`);
      } else {
        name = name + (value as any)[nameField] + ' '
      }
    });
    return name;
  }
  @Watch('value')
  onValueChanged() {
    this.dropdownItems.forEach(item => {
      item.Selected = this.multiselect ? (this.value || []).indexOf(this.getValue(item.Value)) != -1 :
       this.value == this.getValue(item.Value)
    })
  }
  @Watch('items') 
  onItemsChanged()
  {
    this.initDdItems();
  }
  toListViewItem(item: any): ListViewItem<any> {
    (item as IEqual<any>).Equal = (object: any): boolean => {
        var res = this.getValue(item) == this.getValue(object);
        return res;
      }
    (item as IEqual<any>).EqualRelation = (object: any): boolean => this.getListViewValue(item) == this.getListViewValue(object);    
    (item as IEqual<any>).ToString = (): string => this.getString(item);
    const isSelected = this.multiselect ? (this.value || []).indexOf(this.getValue(item)) != -1 :
       this.value == this.getValue(item);
    const result = new ListViewItem<any>(item, isSelected, false);
    return result;
  }
  initDdItems() {
    this.dropdownItems = (this.items || []).map(x=>this.toListViewItem(x));
  }
  sourceListItem: Array<ListViewItem<any>> = [];
  created() {
    this.initDdItems();
    this.sourceListItem = this.dropdownItems;

  }
  changeAutocomlite(search: string) {
    this.dropdownItems = this.sourceListItem.filter(item => (item.Value as any)[this.nameFields[0]].toLowerCase().indexOf(search.toLowerCase()) != -1);
  }
}
